import { Features } from "controls";
import { RequestFeatures, AdultSpecialConditions, TeenagerSpecialConditions, ApplicantIdentityDocument, ApplicantIdentityDocumentType, CitizenshipCertificate, FPMailingInfo, RequestGoal, RepresentativeIdentityDocument, RepresentativeIdentityDocumentType, RequestCause, MobileOptions, Applicant } from './features';
import { RequestFeaturesV2, RequestCauseV2, RepresentativeProofDocumentV2, RepresentativeProofDocumentTypeV2, TrustRecipientV2, IndependentChildDocumentV2, IndependentChildDocumentTypeV2, ExtendedRestrictionV2, RestrictionV2, ApplicantV2 } from './features2';

export class UserModelVisibilityStationary {
  private static v1() {
    // Master flags
    Features.visibleField(RequestFeatures, x => x.stationaryOptions, x => true);
    Features.visibleField(RequestFeatures, x => x.ambulanceOptions, x => false);
    Features.visibleField(RequestFeatures, x => x.mobileOptions, x => false);
    Features.visibleField(RequestFeatures, x => x.fingerprintsRequired, x => (x.isFingerprintCapable() || !!x.applicant.fingerprints.hash) && !x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.fingerprintsPresent, x => (x.isFingerprintCapable() || !!x.applicant.fingerprints.hash) && !x.isDesiredPassportTypeDipService());

    // Applicant
    Features.visibleField(RequestFeatures, x => x.applicant.jobRecords, x => x.isAdult() || x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.applicant.jobManDate, x => x.isAdult() && !x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.applicant.jobManName, x => x.isAdult() && !x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.applicant.hrManager.fullName.firstName, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.applicant.hrManager.fullName.lastName, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.applicant.hrManager.fullName.middleName, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.applicant.hrManager.phone, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.applicant.hrManager.position, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.residenceCountry, x => x.goal === RequestGoal.LivingAbroad);
    Features.visibleField(RequestFeatures, x => x.departureRestrictions, x => x.isAdult() && !x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.secretAccess, x => x.isAdult() && !x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.militaryService, x => x.isAdult() && !x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.dipServiceControlData.dutyCountry, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.dipServiceControlData.dutyDuration, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.dipServiceControlData.dutyOrganization, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.dipServiceControlData.dutyPosition, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.dipServiceControlData.contracts, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.dipServiceControlData.secretAdmitted, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.dipServiceControlData.secretAware, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeatures, x => x.dipServiceControlData.trips, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(ApplicantIdentityDocument,
      x => x.series,
      x => x.type === ApplicantIdentityDocumentType.BirthCertificate || x.type === ApplicantIdentityDocumentType.RussianPassport
    );
    Features.visibleField(ApplicantIdentityDocument,
      x => x.number,
      x => x.type === ApplicantIdentityDocumentType.BirthCertificate || x.type === ApplicantIdentityDocumentType.RussianPassport
    );
    Features.visibleField(ApplicantIdentityDocument,
      x => x.issuer,
      x => x.type === ApplicantIdentityDocumentType.BirthCertificate || x.type === ApplicantIdentityDocumentType.RussianPassport
    );
    Features.visibleField(ApplicantIdentityDocument,
      x => x.issueDate,
      x => x.type === ApplicantIdentityDocumentType.BirthCertificate || x.type === ApplicantIdentityDocumentType.RussianPassport
    );
    Features.visibleField(RequestFeatures, x => x.citizenshipCertificate, x => !x.isHomelandDepartment());
    Features.visibleField(CitizenshipCertificate, x => x.number, x => x.active);
    Features.visibleField(CitizenshipCertificate, x => x.date, x => x.active);
    Features.visibleField(CitizenshipCertificate, x => x.officerPost, x => x.active);
    Features.visibleField(CitizenshipCertificate, x => x.officerName, x => x.active);
    Features.visibleField(CitizenshipCertificate, x => x.testimony, x => x.active);
    Features.visibleField(RequestFeatures, x => x.mailing, x => !x.isHomelandDepartment());
    Features.visibleField(FPMailingInfo, x => x.addressRus, x => x.active);
    Features.visibleField(FPMailingInfo, x => x.addressLat, x => x.active);

    // Representative
    Features.visibleField(RequestFeatures, x => x.representative, x => !x.isAdult() && !x.isDesiredPassportTypeDipService());
    Features.visibleField(RepresentativeIdentityDocument,
      x => x.series,
      x => x.type === RepresentativeIdentityDocumentType.Custom || x.type === RepresentativeIdentityDocumentType.RussianPassport || x.type === RepresentativeIdentityDocumentType.RussianForeignPassport
    );
    Features.visibleField(RepresentativeIdentityDocument,
      x => x.number,
      x => x.type === RepresentativeIdentityDocumentType.Custom || x.type === RepresentativeIdentityDocumentType.RussianPassport || x.type === RepresentativeIdentityDocumentType.RussianForeignPassport
    );
    Features.visibleField(RepresentativeIdentityDocument,
      x => x.issuer,
      x => x.type === RepresentativeIdentityDocumentType.Custom || x.type === RepresentativeIdentityDocumentType.RussianPassport || x.type === RepresentativeIdentityDocumentType.RussianForeignPassport
    );
    Features.visibleField(RepresentativeIdentityDocument,
      x => x.issueDate,
      x => x.type === RepresentativeIdentityDocumentType.Custom || x.type === RepresentativeIdentityDocumentType.RussianPassport || x.type === RepresentativeIdentityDocumentType.RussianForeignPassport
    );

    // Special conditions
    Features.visibleField(RequestFeatures, x => x.adultSpecialConditions, x => x.isAdult());
    Features.visibleField(RequestFeatures, x => x.teenagerSpecialConditions, x => x.isTeenager());
    Features.visibleField(RequestFeatures,
      x => x.presidentEdict,
      x => x.isAdult() && x.adultSpecialConditions === AdultSpecialConditions.PresidentEdict
        || x.isTeenager() && x.teenagerSpecialConditions === TeenagerSpecialConditions.PresidentEdict
    );
    Features.visibleField(RequestFeatures,
      x => x.citizenshipDecision,
      x => x.isAdult() && x.adultSpecialConditions === AdultSpecialConditions.CitizenshipDecision
        || x.isTeenager() && x.teenagerSpecialConditions === TeenagerSpecialConditions.CitizenshipDecision
    );
    Features.visibleField(RequestFeatures,
      x => x.soldierPermission,
      x => x.isAdult() && x.adultSpecialConditions === AdultSpecialConditions.SoldierPermission
    );

    // Foreign passports
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassport,
      x => x.cause === RequestCause.InsteadOfUsedPassport || x.cause === RequestCause.InsteadOfSpoiltPassport || x.cause === RequestCause.InsteadOfLostPassport
    );
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassports.p1,
      x => (x.cause === RequestCause.InsteadOfUsedPassport || x.cause === RequestCause.InsteadOfSpoiltPassport || x.cause === RequestCause.InsteadOfLostPassport) && x.applicant.activeFPassport || x.cause === RequestCause.SecondPassport || x.cause === RequestCause.SecondPassportUntilFirstExpired
    );
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassports.p1.mustBeCanceled,
      x => x.cause === RequestCause.InsteadOfUsedPassport || x.cause === RequestCause.InsteadOfSpoiltPassport || x.cause === RequestCause.InsteadOfLostPassport
    );
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassports.p1.next,
      x => x.cause === RequestCause.InsteadOfUsedPassport || x.cause === RequestCause.InsteadOfSpoiltPassport || x.cause === RequestCause.InsteadOfLostPassport
    );
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassports.p2,
      x => x.applicant.activeFPassports.p1?.next
    );
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassports.p2.mustBeCanceled,
      x => true
    );
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassports.p2.next,
      x => false
    );
  }

  private static v2() {
    // Master flags
    Features.visibleField(RequestFeaturesV2, x => x.stationaryOptions, x => true);
    Features.visibleField(RequestFeaturesV2, x => x.ambulanceOptions, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.mobileOptions, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.fingerprintsRequired, x => (x.isFingerprintCapable() || !!x.applicant.fingerprints.hash) && !x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.fingerprintsPresent, x => (x.isFingerprintCapable() || !!x.applicant.fingerprints.hash) && !x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.incapable, x => x.isAdult() && !x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.independentChild, x => x.isTeenager() && !x.isDesiredPassportTypeDipService());

    // Applicant
    Features.visibleField(RequestFeaturesV2, x => x.independentChildDocument, x => x.independentChild);
    Features.visibleField(IndependentChildDocumentV2, x => x.series, x => x.type === IndependentChildDocumentTypeV2.SelfSufficientCourtDecision || x.type === IndependentChildDocumentTypeV2.SelfSufficientMarriageCertificate || x.type === IndependentChildDocumentTypeV2.SelfSufficientGuardianDecision);
    Features.visibleField(IndependentChildDocumentV2, x => x.number, x => x.type === IndependentChildDocumentTypeV2.SelfSufficientCourtDecision || x.type === IndependentChildDocumentTypeV2.SelfSufficientMarriageCertificate || x.type === IndependentChildDocumentTypeV2.SelfSufficientGuardianDecision);
    Features.visibleField(IndependentChildDocumentV2, x => x.issuer, x => x.type === IndependentChildDocumentTypeV2.SelfSufficientCourtDecision || x.type === IndependentChildDocumentTypeV2.SelfSufficientMarriageCertificate || x.type === IndependentChildDocumentTypeV2.SelfSufficientGuardianDecision);
    Features.visibleField(IndependentChildDocumentV2, x => x.issueDate, x => x.type === IndependentChildDocumentTypeV2.SelfSufficientCourtDecision || x.type === IndependentChildDocumentTypeV2.SelfSufficientMarriageCertificate || x.type === IndependentChildDocumentTypeV2.SelfSufficientGuardianDecision);
    Features.visibleField(RequestFeaturesV2, x => x.applicant.jobRecords, x => x.isAdult() || x.independentChild || x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.applicant.jobManDate, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.applicant.jobManName, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.applicant.hrManager.fullName.firstName, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.applicant.hrManager.fullName.lastName, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.applicant.hrManager.fullName.middleName, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.applicant.hrManager.phone, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.applicant.hrManager.position, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.secretAccess, x => (x.isAdult() || x.independentChild) && !x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.contractObligations, x => (x.isAdult() || x.independentChild) && !x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.militaryService, x => (x.isAdult() || x.independentChild) && !x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.convicted, x => (x.isAdult() || x.independentChild) && !x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.accused, x => (x.isAdult() || x.independentChild) && !x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.legalObligations, x => (x.isAdult() || x.independentChild) && !x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.bankrupt, x => (x.isAdult() || x.independentChild) && !x.isDesiredPassportTypeDipService());
    Features.visibleField(ExtendedRestrictionV2, x => x.organization, x => x.value === RestrictionV2.Restricted);
    Features.visibleField(ExtendedRestrictionV2, x => x.year, x => x.value === RestrictionV2.Restricted);
    Features.visibleField(RequestFeaturesV2, x => x.citizenshipCertificate, x => !x.isHomelandDepartment());
    Features.visibleField(RequestFeaturesV2, x => x.mailing, x => !x.isHomelandDepartment());
    Features.visibleField(RequestFeaturesV2, x => x.applicant.secondNationality, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.goal, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.dipServiceControlData.dutyCountry, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.dipServiceControlData.dutyDuration, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.dipServiceControlData.dutyOrganization, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.dipServiceControlData.dutyPosition, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.dipServiceControlData.contracts, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.dipServiceControlData.secretAdmitted, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.dipServiceControlData.secretAware, x => x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.dipServiceControlData.trips, x => x.isDesiredPassportTypeDipService());

    // Representative
    Features.visibleField(RequestFeaturesV2, x => x.representative, x => (x.isAdult() && x.incapable || !x.isAdult() && !x.independentChild) && !x.isDesiredPassportTypeDipService());
    Features.visibleField(RequestFeaturesV2, x => x.representative.trustRecipient.active, x => !x.isAdult());
    Features.visibleField(RepresentativeProofDocumentV2, x => x.series, x => x.type === RepresentativeProofDocumentTypeV2.BirthCertificate || x.type === RepresentativeProofDocumentTypeV2.Trustee);
    Features.visibleField(RepresentativeProofDocumentV2, x => x.number, x => x.type === RepresentativeProofDocumentTypeV2.BirthCertificate || x.type === RepresentativeProofDocumentTypeV2.Trustee);
    Features.visibleField(RepresentativeProofDocumentV2, x => x.issuer, x => x.type === RepresentativeProofDocumentTypeV2.BirthCertificate || x.type === RepresentativeProofDocumentTypeV2.Trustee);
    Features.visibleField(RepresentativeProofDocumentV2, x => x.issueDate, x => x.type === RepresentativeProofDocumentTypeV2.BirthCertificate || x.type === RepresentativeProofDocumentTypeV2.Trustee);
    Features.visibleField(TrustRecipientV2, x => x.gender, x => x.active);
    Features.visibleField(TrustRecipientV2, x => x.personIdentity, x => x.active);
    Features.visibleField(TrustRecipientV2, x => x.birthPlace, x => x.active);

    // Special conditions
    Features.visibleField(RequestFeaturesV2, x => x.adultSpecialConditions, x => x.isAdult());
    Features.visibleField(RequestFeaturesV2, x => x.teenagerSpecialConditions, x => x.isTeenager());
    Features.visibleField(RequestFeaturesV2,
      x => x.presidentEdict,
      x => x.isAdult() && x.adultSpecialConditions === AdultSpecialConditions.PresidentEdict
        || x.isTeenager() && x.teenagerSpecialConditions === TeenagerSpecialConditions.PresidentEdict
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.citizenshipDecision,
      x => x.isAdult() && x.adultSpecialConditions === AdultSpecialConditions.CitizenshipDecision
        || x.isTeenager() && x.teenagerSpecialConditions === TeenagerSpecialConditions.CitizenshipDecision
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.soldierPermission,
      x => x.isAdult() && x.adultSpecialConditions === AdultSpecialConditions.SoldierPermission
    );

    // Foreign passports
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassport,
      x => x.cause === RequestCauseV2.InsteadOfUsedOrSpoiltPassport || x.cause === RequestCauseV2.InsteadOfLostPassport
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p1,
      x => (x.cause === RequestCauseV2.InsteadOfUsedOrSpoiltPassport || x.cause === RequestCauseV2.InsteadOfLostPassport) && x.applicant.activeFPassport || x.cause === RequestCauseV2.AdditionToActive || x.cause === RequestCauseV2.InsteadOfActive
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p1.mustBeCanceled,
      x => x.cause === RequestCauseV2.InsteadOfActive || x.cause === RequestCauseV2.InsteadOfLostPassport || x.cause === RequestCauseV2.InsteadOfUsedOrSpoiltPassport
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p1.lost,
      x => x.cause === RequestCauseV2.InsteadOfLostPassport && x.applicant.activeFPassports.p1.mustBeCanceled
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p1.next,
      x => x.cause === RequestCauseV2.InsteadOfActive || x.cause === RequestCauseV2.InsteadOfLostPassport || x.cause === RequestCauseV2.InsteadOfUsedOrSpoiltPassport
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p2,
      x => x.applicant.activeFPassports.p1?.next
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p2.mustBeCanceled,
      x => true
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p2.lost,
      x => x.cause === RequestCauseV2.InsteadOfLostPassport && x.applicant.activeFPassports.p2.mustBeCanceled
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p2.next,
      x => false
    );
  }

  constructor() {
    UserModelVisibilityStationary.v1();
    UserModelVisibilityStationary.v2();
    Features.columns(RequestFeaturesV2, 'Default', [
      { prop: x => x.applicant.personIdentity.fullName.lastName, viewPixelSize: 160, searchable: true, editPercentSize: 33 },
      { prop: x => x.applicant.personIdentity.fullName.firstName, viewPixelSize: 160, searchable: true, editPercentSize: 33 },
      { prop: x => x.applicant.personIdentity.fullName.middleName, viewPixelSize: 160, searchable: true, editPercentSize: 33 }
    ]);
    Features.columns(RequestFeaturesV2, 'Control', [
      { prop: x => x.applicant.personIdentity.fullName.lastName, viewPixelSize: 160, searchable: false, editPercentSize: 33 },
      { prop: x => x.applicant.personIdentity.fullName.firstName, viewPixelSize: 160, searchable: false, editPercentSize: 33 },
      { prop: x => x.applicant.personIdentity.fullName.middleName, viewPixelSize: 160, searchable: false, editPercentSize: 33 },
      { prop: x => x.mailing.active, viewPixelSize: 100, searchable: false, editPercentSize: 33 }
    ]);
  }
}

export class UserModelVisibilityAmbulance {
  private static v1() {
    // Master flags
    Features.visibleField(RequestFeatures, x => x.stationaryOptions, x => false);
    Features.visibleField(RequestFeatures, x => x.ambulanceOptions, x => true);
    Features.visibleField(RequestFeatures, x => x.mobileOptions, x => false);
    Features.visibleField(RequestFeatures, x => x.fingerprintsRequired, x => false);
    Features.visibleField(RequestFeatures, x => x.fingerprintsPresent, x => false);

    // Applicant
    Features.visibleField(RequestFeatures, x => x.applicant.jobRecords, x => x.isAdult());
    Features.visibleField(RequestFeatures, x => x.applicant.jobManDate, x => false);
    Features.visibleField(RequestFeatures, x => x.applicant.jobManName, x => false);
    Features.visibleField(RequestFeatures, x => x.residenceCountry, x => x.goal === RequestGoal.LivingAbroad);
    Features.visibleField(RequestFeatures, x => x.secretAccess, x => x.isAdult());
    Features.visibleField(RequestFeatures, x => x.departureRestrictions, x => x.isAdult());
    Features.visibleField(RequestFeatures, x => x.militaryService, x => x.isAdult());
    Features.visibleField(ApplicantIdentityDocument,
      x => x.series,
      x => x.type === ApplicantIdentityDocumentType.BirthCertificate || x.type === ApplicantIdentityDocumentType.RussianPassport
    );
    Features.visibleField(ApplicantIdentityDocument,
      x => x.number,
      x => x.type === ApplicantIdentityDocumentType.BirthCertificate || x.type === ApplicantIdentityDocumentType.RussianPassport
    );
    Features.visibleField(ApplicantIdentityDocument,
      x => x.issuer,
      x => x.type === ApplicantIdentityDocumentType.BirthCertificate || x.type === ApplicantIdentityDocumentType.RussianPassport
    );
    Features.visibleField(ApplicantIdentityDocument,
      x => x.issueDate,
      x => x.type === ApplicantIdentityDocumentType.BirthCertificate || x.type === ApplicantIdentityDocumentType.RussianPassport
    );
    Features.visibleField(CitizenshipCertificate, x => x.number, x => x.active);
    Features.visibleField(CitizenshipCertificate, x => x.date, x => x.active);
    Features.visibleField(CitizenshipCertificate, x => x.officerPost, x => x.active);
    Features.visibleField(CitizenshipCertificate, x => x.officerName, x => x.active);
    Features.visibleField(CitizenshipCertificate, x => x.testimony, x => x.active);
    Features.visibleField(FPMailingInfo, x => x.addressRus, x => x.active);
    Features.visibleField(FPMailingInfo, x => x.addressLat, x => x.active);

    // Representative
    Features.visibleField(RequestFeatures, x => x.representative, x => !x.isAdult());
    Features.visibleField(RepresentativeIdentityDocument,
      x => x.series,
      x => x.type === RepresentativeIdentityDocumentType.Custom || x.type === RepresentativeIdentityDocumentType.RussianPassport || x.type === RepresentativeIdentityDocumentType.RussianForeignPassport
    );
    Features.visibleField(RepresentativeIdentityDocument,
      x => x.number,
      x => x.type === RepresentativeIdentityDocumentType.Custom || x.type === RepresentativeIdentityDocumentType.RussianPassport || x.type === RepresentativeIdentityDocumentType.RussianForeignPassport
    );
    Features.visibleField(RepresentativeIdentityDocument,
      x => x.issuer,
      x => x.type === RepresentativeIdentityDocumentType.Custom || x.type === RepresentativeIdentityDocumentType.RussianPassport || x.type === RepresentativeIdentityDocumentType.RussianForeignPassport
    );
    Features.visibleField(RepresentativeIdentityDocument,
      x => x.issueDate,
      x => x.type === RepresentativeIdentityDocumentType.Custom || x.type === RepresentativeIdentityDocumentType.RussianPassport || x.type === RepresentativeIdentityDocumentType.RussianForeignPassport
    );

    // Special conditions
    Features.visibleField(RequestFeatures, x => x.adultSpecialConditions, x => x.isAdult());
    Features.visibleField(RequestFeatures, x => x.teenagerSpecialConditions, x => x.isTeenager());
    Features.visibleField(RequestFeatures,
      x => x.presidentEdict,
      x => x.isAdult() && x.adultSpecialConditions === AdultSpecialConditions.PresidentEdict
        || x.isTeenager() && x.teenagerSpecialConditions === TeenagerSpecialConditions.PresidentEdict
    );
    Features.visibleField(RequestFeatures,
      x => x.citizenshipDecision,
      x => x.isAdult() && x.adultSpecialConditions === AdultSpecialConditions.CitizenshipDecision
        || x.isTeenager() && x.teenagerSpecialConditions === TeenagerSpecialConditions.CitizenshipDecision
    );
    Features.visibleField(RequestFeatures,
      x => x.soldierPermission,
      x => x.isAdult() && x.adultSpecialConditions === AdultSpecialConditions.SoldierPermission
    );

    // Foreign passports
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassport,
      x => x.cause === RequestCause.InsteadOfUsedPassport || x.cause === RequestCause.InsteadOfSpoiltPassport || x.cause === RequestCause.InsteadOfLostPassport
    );
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassports.p1,
      x => (x.cause === RequestCause.InsteadOfUsedPassport || x.cause === RequestCause.InsteadOfSpoiltPassport || x.cause === RequestCause.InsteadOfLostPassport) && x.applicant.activeFPassport || x.cause === RequestCause.SecondPassport
    );
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassports.p1.mustBeCanceled,
      x => x.cause === RequestCause.InsteadOfUsedPassport || x.cause === RequestCause.InsteadOfSpoiltPassport || x.cause === RequestCause.InsteadOfLostPassport
    );
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassports.p1.next,
      x => x.cause === RequestCause.InsteadOfUsedPassport || x.cause === RequestCause.InsteadOfSpoiltPassport || x.cause === RequestCause.InsteadOfLostPassport
    );
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassports.p2,
      x => x.applicant.activeFPassports.p1?.next
    );
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassports.p2.mustBeCanceled,
      x => true
    );
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassports.p2.next,
      x => false
    );
  }

  private static v2() {
    // Master flags
    Features.visibleField(RequestFeaturesV2, x => x.stationaryOptions, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.ambulanceOptions, x => true);
    Features.visibleField(RequestFeaturesV2, x => x.mobileOptions, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.fingerprintsRequired, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.fingerprintsPresent, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.incapable, x => x.isAdult());
    Features.visibleField(RequestFeaturesV2, x => x.independentChild, x => x.isTeenager());

    // Applicant
    Features.visibleField(RequestFeaturesV2, x => x.independentChildDocument, x => x.independentChild);
    Features.visibleField(IndependentChildDocumentV2, x => x.series, x => x.type === IndependentChildDocumentTypeV2.SelfSufficientCourtDecision || x.type === IndependentChildDocumentTypeV2.SelfSufficientMarriageCertificate || x.type === IndependentChildDocumentTypeV2.SelfSufficientGuardianDecision);
    Features.visibleField(IndependentChildDocumentV2, x => x.number, x => x.type === IndependentChildDocumentTypeV2.SelfSufficientCourtDecision || x.type === IndependentChildDocumentTypeV2.SelfSufficientMarriageCertificate || x.type === IndependentChildDocumentTypeV2.SelfSufficientGuardianDecision);
    Features.visibleField(IndependentChildDocumentV2, x => x.issuer, x => x.type === IndependentChildDocumentTypeV2.SelfSufficientCourtDecision || x.type === IndependentChildDocumentTypeV2.SelfSufficientMarriageCertificate || x.type === IndependentChildDocumentTypeV2.SelfSufficientGuardianDecision);
    Features.visibleField(IndependentChildDocumentV2, x => x.issueDate, x => x.type === IndependentChildDocumentTypeV2.SelfSufficientCourtDecision || x.type === IndependentChildDocumentTypeV2.SelfSufficientMarriageCertificate || x.type === IndependentChildDocumentTypeV2.SelfSufficientGuardianDecision);
    Features.visibleField(RequestFeaturesV2, x => x.applicant.jobRecords, x => x.isAdult() || x.independentChild);
    Features.visibleField(RequestFeaturesV2, x => x.applicant.jobManDate, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.applicant.jobManName, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.secretAccess, x => x.isAdult() || x.independentChild);
    Features.visibleField(RequestFeaturesV2, x => x.contractObligations, x => x.isAdult() || x.independentChild);
    Features.visibleField(RequestFeaturesV2, x => x.militaryService, x => x.isAdult() || x.independentChild);
    Features.visibleField(RequestFeaturesV2, x => x.convicted, x => x.isAdult() || x.independentChild);
    Features.visibleField(RequestFeaturesV2, x => x.accused, x => x.isAdult() || x.independentChild);
    Features.visibleField(RequestFeaturesV2, x => x.legalObligations, x => x.isAdult() || x.independentChild);
    Features.visibleField(RequestFeaturesV2, x => x.bankrupt, x => x.isAdult() || x.independentChild);
    Features.visibleField(ExtendedRestrictionV2, x => x.organization, x => x.value === RestrictionV2.Restricted);
    Features.visibleField(ExtendedRestrictionV2, x => x.year, x => x.value === RestrictionV2.Restricted);

    // Representative
    Features.visibleField(RequestFeaturesV2, x => x.representative, x => x.isAdult() && x.incapable || !x.isAdult() && !x.independentChild);
    Features.visibleField(RequestFeaturesV2, x => x.representative.trustRecipient.active, x => !x.isAdult());
    Features.visibleField(RepresentativeProofDocumentV2, x => x.series, x => x.type === RepresentativeProofDocumentTypeV2.BirthCertificate || x.type === RepresentativeProofDocumentTypeV2.Trustee);
    Features.visibleField(RepresentativeProofDocumentV2, x => x.number, x => x.type === RepresentativeProofDocumentTypeV2.BirthCertificate || x.type === RepresentativeProofDocumentTypeV2.Trustee);
    Features.visibleField(RepresentativeProofDocumentV2, x => x.issuer, x => x.type === RepresentativeProofDocumentTypeV2.BirthCertificate || x.type === RepresentativeProofDocumentTypeV2.Trustee);
    Features.visibleField(RepresentativeProofDocumentV2, x => x.issueDate, x => x.type === RepresentativeProofDocumentTypeV2.BirthCertificate || x.type === RepresentativeProofDocumentTypeV2.Trustee);
    Features.visibleField(TrustRecipientV2, x => x.gender, x => x.active);
    Features.visibleField(TrustRecipientV2, x => x.personIdentity, x => x.active);
    Features.visibleField(TrustRecipientV2, x => x.birthPlace, x => x.active);

    // Special conditions
    Features.visibleField(RequestFeaturesV2, x => x.adultSpecialConditions, x => x.isAdult());
    Features.visibleField(RequestFeaturesV2, x => x.teenagerSpecialConditions, x => x.isTeenager());
    Features.visibleField(RequestFeaturesV2,
      x => x.presidentEdict,
      x => x.isAdult() && x.adultSpecialConditions === AdultSpecialConditions.PresidentEdict
        || x.isTeenager() && x.teenagerSpecialConditions === TeenagerSpecialConditions.PresidentEdict
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.citizenshipDecision,
      x => x.isAdult() && x.adultSpecialConditions === AdultSpecialConditions.CitizenshipDecision
        || x.isTeenager() && x.teenagerSpecialConditions === TeenagerSpecialConditions.CitizenshipDecision
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.soldierPermission,
      x => x.isAdult() && x.adultSpecialConditions === AdultSpecialConditions.SoldierPermission
    );

    // Foreign passports
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassport,
      x => x.cause === RequestCauseV2.InsteadOfUsedOrSpoiltPassport || x.cause === RequestCauseV2.InsteadOfLostPassport
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p1,
      x => (x.cause === RequestCauseV2.InsteadOfUsedOrSpoiltPassport || x.cause === RequestCauseV2.InsteadOfLostPassport) && x.applicant.activeFPassport || x.cause === RequestCauseV2.AdditionToActive || x.cause === RequestCauseV2.InsteadOfActive
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p1.mustBeCanceled,
      x => x.cause === RequestCauseV2.InsteadOfActive || x.cause === RequestCauseV2.InsteadOfLostPassport || x.cause === RequestCauseV2.InsteadOfUsedOrSpoiltPassport
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p1.lost,
      x => x.cause === RequestCauseV2.InsteadOfLostPassport && x.applicant.activeFPassports.p1.mustBeCanceled
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p1.next,
      x => x.cause === RequestCauseV2.InsteadOfActive || x.cause === RequestCauseV2.InsteadOfLostPassport || x.cause === RequestCauseV2.InsteadOfUsedOrSpoiltPassport
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p2,
      x => x.applicant.activeFPassports.p1?.next
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p2.mustBeCanceled,
      x => true
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p2.lost,
      x => x.cause === RequestCauseV2.InsteadOfLostPassport && x.applicant.activeFPassports.p2.mustBeCanceled
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p2.next,
      x => false
    );
  }

  constructor() {
    UserModelVisibilityAmbulance.v1();
    UserModelVisibilityAmbulance.v2();
    Features.columns(RequestFeaturesV2, 'Default', [
      { prop: x => x.applicant.personIdentity.fullName.lastName, viewPixelSize: 160, searchable: true, editPercentSize: 33 },
      { prop: x => x.applicant.personIdentity.fullName.firstName, viewPixelSize: 160, searchable: true, editPercentSize: 33 },
      { prop: x => x.applicant.personIdentity.fullName.middleName, viewPixelSize: 160, searchable: true, editPercentSize: 33 }
    ]);
    Features.columns(RequestFeaturesV2, 'Control', [
      { prop: x => x.applicant.personIdentity.fullName.lastName, viewPixelSize: 160, searchable: false, editPercentSize: 33 },
      { prop: x => x.applicant.personIdentity.fullName.firstName, viewPixelSize: 160, searchable: false, editPercentSize: 33 },
      { prop: x => x.applicant.personIdentity.fullName.middleName, viewPixelSize: 160, searchable: false, editPercentSize: 33 },
      { prop: x => x.mailing.active, viewPixelSize: 100, searchable: false, editPercentSize: 33 }
    ]);
  }
}

export class UserModelVisibilityMobile {
  private static v1() {
    // Master flags
    Features.visibleField(RequestFeatures, x => x.stationaryOptions, x => false);
    Features.visibleField(RequestFeatures, x => x.ambulanceOptions, x => false);
    Features.visibleField(RequestFeatures, x => x.mobileOptions, x => true);
    Features.visibleField(RequestFeatures, x => x.fingerprintsRequired, x => false);
    Features.visibleField(RequestFeatures, x => x.fingerprintsPresent, x => false);
    Features.visibleField(RequestFeatures, x => x.citizenshipCertificate, x => false);
    Features.visibleField(RequestFeatures, x => x.mailing, x => x.mobileOptions.departmentUsesPassportMail);

    // Applicant
    Features.stringOptions(Applicant, x => x.lastNameLat, false, true, true);
    Features.stringOptions(Applicant, x => x.firstNameLat, false, true, true);
    Features.visibleField(RequestFeatures, x => x.applicant.jobRecords, x => x.isAdult());
    Features.visibleField(RequestFeatures, x => x.applicant.jobManDate, x => false);
    Features.visibleField(RequestFeatures, x => x.applicant.jobManName, x => false);
    Features.visibleField(RequestFeatures, x => x.residenceCountry, x => x.goal === RequestGoal.LivingAbroad);
    Features.visibleField(RequestFeatures, x => x.secretAccess, x => x.isAdult());
    Features.visibleField(RequestFeatures, x => x.departureRestrictions, x => x.isAdult());
    Features.visibleField(RequestFeatures, x => x.militaryService, x => x.isAdult());
    Features.visibleField(ApplicantIdentityDocument,
      x => x.series,
      x => x.type === ApplicantIdentityDocumentType.BirthCertificate || x.type === ApplicantIdentityDocumentType.RussianPassport
    );
    Features.visibleField(ApplicantIdentityDocument,
      x => x.number,
      x => x.type === ApplicantIdentityDocumentType.BirthCertificate || x.type === ApplicantIdentityDocumentType.RussianPassport
    );
    Features.visibleField(ApplicantIdentityDocument,
      x => x.issuer,
      x => x.type === ApplicantIdentityDocumentType.BirthCertificate || x.type === ApplicantIdentityDocumentType.RussianPassport
    );
    Features.visibleField(ApplicantIdentityDocument,
      x => x.issueDate,
      x => x.type === ApplicantIdentityDocumentType.BirthCertificate || x.type === ApplicantIdentityDocumentType.RussianPassport
    );
    Features.visibleField(CitizenshipCertificate, x => x.number, x => x.active);
    Features.visibleField(CitizenshipCertificate, x => x.date, x => x.active);
    Features.visibleField(CitizenshipCertificate, x => x.officerPost, x => x.active);
    Features.visibleField(CitizenshipCertificate, x => x.officerName, x => x.active);
    Features.visibleField(CitizenshipCertificate, x => x.testimony, x => x.active);
    Features.visibleField(FPMailingInfo, x => x.addressRus, x => x.active);
    Features.visibleField(FPMailingInfo, x => x.addressLat, x => x.active);
    Features.visibleField(MobileOptions, x => x.sendAppViaInternet, x => x.departmentUsesInternetApps);
    Features.visibleField(MobileOptions, x => x.sendAppViaInternetWithFIO, x => x.sendAppViaInternet);

    // Representative
    Features.visibleField(RequestFeatures, x => x.representative, x => !x.isAdult());
    Features.visibleField(RepresentativeIdentityDocument,
      x => x.series,
      x => x.type === RepresentativeIdentityDocumentType.Custom || x.type === RepresentativeIdentityDocumentType.RussianPassport || x.type === RepresentativeIdentityDocumentType.RussianForeignPassport
    );
    Features.visibleField(RepresentativeIdentityDocument,
      x => x.number,
      x => x.type === RepresentativeIdentityDocumentType.Custom || x.type === RepresentativeIdentityDocumentType.RussianPassport || x.type === RepresentativeIdentityDocumentType.RussianForeignPassport
    );
    Features.visibleField(RepresentativeIdentityDocument,
      x => x.issuer,
      x => x.type === RepresentativeIdentityDocumentType.Custom || x.type === RepresentativeIdentityDocumentType.RussianPassport || x.type === RepresentativeIdentityDocumentType.RussianForeignPassport
    );
    Features.visibleField(RepresentativeIdentityDocument,
      x => x.issueDate,
      x => x.type === RepresentativeIdentityDocumentType.Custom || x.type === RepresentativeIdentityDocumentType.RussianPassport || x.type === RepresentativeIdentityDocumentType.RussianForeignPassport
    );

    // Special conditions
    Features.visibleField(RequestFeatures, x => x.adultSpecialConditions, x => false);
    Features.visibleField(RequestFeatures, x => x.teenagerSpecialConditions, x => false);
    Features.visibleField(RequestFeatures, x => x.presidentEdict, x => false);
    Features.visibleField(RequestFeatures, x => x.citizenshipDecision, x => false);
    Features.visibleField(RequestFeatures, x => x.soldierPermission, x => false);
    Features.visibleField(RequestFeatures, x => x.receptionUser, x => false);

    // Foreign passports
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassport,
      x => x.cause === RequestCause.InsteadOfUsedPassport || x.cause === RequestCause.InsteadOfSpoiltPassport || x.cause === RequestCause.InsteadOfLostPassport
    );
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassports.p1,
      x => (x.cause === RequestCause.InsteadOfUsedPassport || x.cause === RequestCause.InsteadOfSpoiltPassport || x.cause === RequestCause.InsteadOfLostPassport) && x.applicant.activeFPassport || x.cause === RequestCause.SecondPassport
    );
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassports.p1.mustBeCanceled,
      x => x.cause === RequestCause.InsteadOfUsedPassport || x.cause === RequestCause.InsteadOfSpoiltPassport || x.cause === RequestCause.InsteadOfLostPassport
    );
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassports.p1.next,
      x => x.cause === RequestCause.InsteadOfUsedPassport || x.cause === RequestCause.InsteadOfSpoiltPassport || x.cause === RequestCause.InsteadOfLostPassport
    );
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassports.p2,
      x => x.applicant.activeFPassports.p1?.next
    );
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassports.p2.mustBeCanceled,
      x => true
    );
    Features.visibleField(RequestFeatures,
      x => x.applicant.activeFPassports.p2.next,
      x => false
    );
  }

  private static v2() {
    // Master flags
    Features.visibleField(RequestFeaturesV2, x => x.stationaryOptions, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.ambulanceOptions, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.mobileOptions, x => true);
    Features.visibleField(RequestFeaturesV2, x => x.fingerprintsRequired, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.fingerprintsPresent, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.citizenshipCertificate, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.mailing, x => x.mobileOptions.departmentUsesPassportMail);
    Features.visibleField(RequestFeaturesV2, x => x.incapable, x => x.isAdult());
    Features.visibleField(RequestFeaturesV2, x => x.independentChild, x => x.isTeenager());

    // Applicant
    Features.stringOptions(ApplicantV2, x => x.lastNameLat, false, true, true);
    Features.stringOptions(ApplicantV2, x => x.firstNameLat, false, true, true);
    Features.visibleField(RequestFeaturesV2, x => x.independentChildDocument, x => x.independentChild);
    Features.visibleField(IndependentChildDocumentV2, x => x.series, x => x.type === IndependentChildDocumentTypeV2.SelfSufficientCourtDecision || x.type === IndependentChildDocumentTypeV2.SelfSufficientMarriageCertificate || x.type === IndependentChildDocumentTypeV2.SelfSufficientGuardianDecision);
    Features.visibleField(IndependentChildDocumentV2, x => x.number, x => x.type === IndependentChildDocumentTypeV2.SelfSufficientCourtDecision || x.type === IndependentChildDocumentTypeV2.SelfSufficientMarriageCertificate || x.type === IndependentChildDocumentTypeV2.SelfSufficientGuardianDecision);
    Features.visibleField(IndependentChildDocumentV2, x => x.issuer, x => x.type === IndependentChildDocumentTypeV2.SelfSufficientCourtDecision || x.type === IndependentChildDocumentTypeV2.SelfSufficientMarriageCertificate || x.type === IndependentChildDocumentTypeV2.SelfSufficientGuardianDecision);
    Features.visibleField(IndependentChildDocumentV2, x => x.issueDate, x => x.type === IndependentChildDocumentTypeV2.SelfSufficientCourtDecision || x.type === IndependentChildDocumentTypeV2.SelfSufficientMarriageCertificate || x.type === IndependentChildDocumentTypeV2.SelfSufficientGuardianDecision);
    Features.visibleField(RequestFeaturesV2, x => x.applicant.jobRecords, x => x.isAdult() || x.independentChild);
    Features.visibleField(RequestFeaturesV2, x => x.applicant.jobManDate, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.applicant.jobManName, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.secretAccess, x => x.isAdult() || x.independentChild);
    Features.visibleField(RequestFeaturesV2, x => x.contractObligations, x => x.isAdult() || x.independentChild);
    Features.visibleField(RequestFeaturesV2, x => x.militaryService, x => x.isAdult() || x.independentChild);
    Features.visibleField(RequestFeaturesV2, x => x.convicted, x => x.isAdult() || x.independentChild);
    Features.visibleField(RequestFeaturesV2, x => x.accused, x => x.isAdult() || x.independentChild);
    Features.visibleField(RequestFeaturesV2, x => x.legalObligations, x => x.isAdult() || x.independentChild);
    Features.visibleField(RequestFeaturesV2, x => x.bankrupt, x => x.isAdult() || x.independentChild);
    Features.visibleField(ExtendedRestrictionV2, x => x.organization, x => x.value === RestrictionV2.Restricted);
    Features.visibleField(ExtendedRestrictionV2, x => x.year, x => x.value === RestrictionV2.Restricted);

    // Representative
    Features.visibleField(RequestFeaturesV2, x => x.representative, x => x.isAdult() && x.incapable || !x.isAdult() && !x.independentChild);
    Features.visibleField(RequestFeaturesV2, x => x.representative.trustRecipient.active, x => !x.isAdult());
    Features.visibleField(RepresentativeProofDocumentV2, x => x.series, x => x.type === RepresentativeProofDocumentTypeV2.BirthCertificate || x.type === RepresentativeProofDocumentTypeV2.Trustee);
    Features.visibleField(RepresentativeProofDocumentV2, x => x.number, x => x.type === RepresentativeProofDocumentTypeV2.BirthCertificate || x.type === RepresentativeProofDocumentTypeV2.Trustee);
    Features.visibleField(RepresentativeProofDocumentV2, x => x.issuer, x => x.type === RepresentativeProofDocumentTypeV2.BirthCertificate || x.type === RepresentativeProofDocumentTypeV2.Trustee);
    Features.visibleField(RepresentativeProofDocumentV2, x => x.issueDate, x => x.type === RepresentativeProofDocumentTypeV2.BirthCertificate || x.type === RepresentativeProofDocumentTypeV2.Trustee);
    Features.visibleField(TrustRecipientV2, x => x.gender, x => x.active);
    Features.visibleField(TrustRecipientV2, x => x.personIdentity, x => x.active);
    Features.visibleField(TrustRecipientV2, x => x.birthPlace, x => x.active);

    // Special conditions
    Features.visibleField(RequestFeaturesV2, x => x.adultSpecialConditions, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.teenagerSpecialConditions, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.presidentEdict, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.citizenshipDecision, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.soldierPermission, x => false);
    Features.visibleField(RequestFeaturesV2, x => x.receptionUser, x => false);

    // Foreign passports
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassport,
      x => x.cause === RequestCauseV2.InsteadOfLostPassport || x.cause === RequestCauseV2.InsteadOfUsedOrSpoiltPassport
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p1,
      x => (x.cause === RequestCauseV2.InsteadOfLostPassport || x.cause === RequestCauseV2.InsteadOfUsedOrSpoiltPassport) && x.applicant.activeFPassport || x.cause === RequestCauseV2.AdditionToActive || x.cause === RequestCauseV2.InsteadOfActive
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p1.mustBeCanceled,
      x => x.cause === RequestCauseV2.InsteadOfActive || x.cause === RequestCauseV2.InsteadOfLostPassport || x.cause === RequestCauseV2.InsteadOfUsedOrSpoiltPassport
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p1.lost,
      x => x.cause === RequestCauseV2.InsteadOfLostPassport && x.applicant.activeFPassports.p1.mustBeCanceled
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p1.next,
      x => x.cause === RequestCauseV2.InsteadOfActive || x.cause === RequestCauseV2.InsteadOfLostPassport || x.cause === RequestCauseV2.InsteadOfUsedOrSpoiltPassport
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p2,
      x => x.applicant.activeFPassports.p1?.next
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p2.mustBeCanceled,
      x => true
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p2.lost,
      x => x.cause === RequestCauseV2.InsteadOfLostPassport && x.applicant.activeFPassports.p2.mustBeCanceled
    );
    Features.visibleField(RequestFeaturesV2,
      x => x.applicant.activeFPassports.p2.next,
      x => false
    );
  }

  constructor() {
    UserModelVisibilityMobile.v1();
    UserModelVisibilityMobile.v2();
    Features.columns(RequestFeaturesV2, 'Default', [
      { prop: x => x.applicant.personIdentity.fullName.lastName, viewPixelSize: 160, searchable: true, editPercentSize: 33 },
      { prop: x => x.applicant.personIdentity.fullName.firstName, viewPixelSize: 160, searchable: true, editPercentSize: 33 },
      { prop: x => x.applicant.personIdentity.fullName.middleName, viewPixelSize: 160, searchable: true, editPercentSize: 33 },
      { prop: (x: any) => x._dept, viewPixelSize: 120, searchable: false, editPercentSize: 33 },
      { prop: (x: any) => x._printed, viewPixelSize: 120, searchable: false, editPercentSize: 33 }
    ]);
    Features.columns(RequestFeaturesV2, 'Phone', [
      { prop: x => x.asString_, viewPixelSize: 160, searchable: false, editPercentSize: 33 }
    ]);
  }
}
